import { Component, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { GeoAreaMslRespectMonitoringKpi } from 'src/app/assabil-sales/models/dtos/geo-area-msl-respect-monitoring-kpi';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';
import { SkuMslKpi } from 'src/app/assabil-kernel/models/entities/control-tables/sku-msl-kpi-entity';
import { Partnercluster } from 'src/app/assabil-sales/models/entities/partnercluster';


  @Component({
    selector: 'danone-msl-respect-monitoring-widget',
    templateUrl: './danone-msl-respect-monitoring-widget.component.html',
    styleUrls: ['./danone-msl-respect-monitoring-widget.component.scss']
  })
  
  export class DanoneMslRespectMonitoringWidgetComponent extends BaseWidget {

    @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
    geoArea             : GeoArea;
    selectedGeoArea     : GeoArea = null
    date                : Date = new Date();
    dateTemp            : Date = new Date();
    title               : string = "Monitoring Respect MSL";
    detailTitle         : string = "";
    previousPeriod      : string = "12/2030";

    itineraryType  : string;
    partnerCluster : string;
    geoAreaCode    : string;
    kpi            : string;
    periodActiveDay: Date;

    geoAreaMslRespectMonitoringKpi :  GeoAreaMslRespectMonitoringKpi;

    mslRespectGeoAreas : any[] = [];

    mslRespectGeoAreasDetailsColumns = [
  
      { prop: 'geoAreaCode',   name: 'Code Area',        },
      { prop: 'geoAreaName',   name: 'Designation',      },
  
      { prop: 'weekS_0',       name: 'S',                },
      { prop: 'weekS_1',       name: 'S - 1',            },
      { prop: 'weekS_2',       name: 'S - 2',            },
      { prop: 'weekS_3',       name: 'S - 3',            },
      { prop: 'weekS_4',       name: 'S - 4',            },
  
    ]

    showMslRespectGeoAreas : boolean = false;
    

    constructor(
      protected datepipe: DatePipe,
      protected specificDanoneService   : SpecificDanoneService,
      protected controlTablesService    : ControlTablesService,
      protected leanUtilsService        : LeanUtilsService,
      protected masterDataService       : MasterDataService,
      protected toastr                  : ToastrService,
      protected router                  : Router,
      protected location                : Location) {
        super(toastr, leanUtilsService);
        
  
    }
  
  //----------------------------------------------------------------------------------------------------------------------------------
  ngOnInit(){
    this.date.setDate(this.date.getDate() - 1);
    super.ngOnInit();
    this.controlTablesService.personGeoAreaGet().then(result => {
      this.geoArea = result;
    })
  }
  //----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------------------------------------------------------------------
  loadData() {
    if ( (! this.selectedGeoArea) ||   (! this.date) ){
      this.toastr.error("Prière de préciser les paramètres de la recherhe");
      return;
    }
    
    this.specificDanoneService.geoAreaMslRespectMonitoringKpisGet(this.selectedGeoArea.geoAreaCode, this.date).then(geoAreaMslRespectMonitoringKpi => {
        this.geoAreaMslRespectMonitoringKpi = geoAreaMslRespectMonitoringKpi;
    })
    this.dateTemp.setFullYear(this.date.getFullYear(), this.date.getMonth() - 1, this.date.getDate());
    this.title = "Suivi Respect MSL - Date : " + this.datepipe.transform(this.date, 'dd/MM/yyyy') + " | " + this.selectedGeoArea.name;
  }
 //----------------------------------------------------------------------------------------------------------------------------------

 //----------------------------------------------------------------------------------------------------------------------------------

 itineraryTypeclicked(event : any){
  this.itineraryType   = event.itineraryType;
  this.partnerCluster  = event.partnerCluster;
  this.geoAreaCode     = event.geoArea.geoAreaCode;
  this.periodActiveDay = this.date;

  if (this.partnerCluster != 'ALL') {
  this.specificDanoneService.danoneMslRespectGeoAreasGet(this.periodActiveDay, this.itineraryType, this.partnerCluster, this.geoAreaCode).then(result => {
    this.mslRespectGeoAreas  = result;
    this.showMslRespectGeoAreas = true;
    this.detailTitle = "Détail - Date: " + this.datepipe.transform(this.date, 'dd/MM/yyyy') + " | Type Tournées: " + event.itineraryTypeName +  " | Cluster: " + event.partnerCluster +  " | Area: " + event.geoArea.name
    // console.log("result : ", result)
    // console.log("mslRespectGeoAreas : ", this.mslRespectGeoAreas)
    // console.log("itineraryType : ", this.itineraryType)
    // console.log("partnerCluster : ", this.partnerCluster)
    // console.log("geoAreaCode : ", this.geoAreaCode)
})
}
}
//----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------
  selectGeoAreaAndGo(geoArea : GeoArea){ 
    this.selectGeoArea(geoArea);
    this.leanDataForm.hideFilter();
    this.loadData();
  }
  selectGeoArea(geoArea : GeoArea){
    if (this.selectedGeoArea != null) this.selectedGeoArea.selected = false;
    this.selectedGeoArea = geoArea;
    this.selectedGeoArea.selected=true;
  }
//----------------------------------------------------------------------


//--------------------------------------------------------------------------------------
returnBack(){
  this.location.back();
}

  setEntity(data: BaseEntity) {
    throw new Error("Method not implemented.");
  }
  getEntity(): BaseEntity {
    throw new Error("Method not implemented.");
  }
  saveRow(): Promise<BaseEntity> {
    throw new Error("Method not implemented.");
  }
  //--------------------------------------------------------------------------------------
    
  }
  
  